import PrintIcon from '@material-ui/icons/Print';
import ToolbarItem from 'components/Toolbar/ToolbarItem';
const printIcon = React.createElement(PrintIcon, null);
// @ts-ignore
const ToolbarPrintItem = React.forwardRef((props, ref) => {
    return React.createElement(ToolbarItem, Object.assign({ ref: ref, icon: printIcon, text: "\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C" }, props));
});
export default React.memo(ToolbarPrintItem);
